import { outboundConstants } from '../../_constants';
export function outbound(state = {}, action) {
    switch (action.type) {
        case outboundConstants.OUTBOUND_FETCHING:
            return {
                ...state,
                outboundFetching: true
            };
        case outboundConstants.OUTBOUND_FETCHED:
            return {
                ...state,
                outboundFetching: false
            };
        case outboundConstants.OUTBOUND_SUBMITTING:
            return {
                ...state,
                outboundSubmitting: true
            };
        case outboundConstants.OUTBOUND_SUBMITTED:
            return {
                ...state,
                outboundSubmitting: false
            };
        case outboundConstants.OUTBOUND_SUCCESS:
            return {
                ...state,
                isSuccess: action.isSuccess
            };
        case outboundConstants.CLEAR_LOAD_LIST:
            return {
                loadList: null
            }
        case outboundConstants.OUTBOUND_BOOKING_ATW:
            return {
                outboundBookingAtw: action.outboundBookingAtw
            };
        case outboundConstants.OUTBOUND_BOOKING_CBS:
            return {
                ...state,
                outboundBookingCbs: action.outboundBookingCbs
            };
        case outboundConstants.LOAD_CTS:
            return {
                ...state,
                cts: action.cts
            };
        case outboundConstants.OUTBOUND_CTS:
            return {
                ...state,
                outboundCts: action.outboundCts
            };
        case outboundConstants.OUTBOUND_BOOKING_CTS:
            return {
                ...state,
                outboundBookingCts: action.outboundBookingCts
            };
        case outboundConstants.OUTBOUND_BOOKING_CTS_TANDEM:
            return {
                ...state,
                outboundBookingCtsTandem: action.outboundBookingCtsTandem
            };
        case outboundConstants.LOAD_WAYBILL:
            return {
                ...state,
                waybill: action.waybill
            };
        case outboundConstants.OUTBOUND_WAYBILL:
            return {
                ...state,
                outboundWaybill: action.outboundWaybill
            };
        case outboundConstants.OUTBOUND_WAYBILL_TANDEM:
            return {
                ...state,
                outboundWaybillTandem: action.outboundWaybillTandem
            };
        case outboundConstants.OUTBOUND_BOOKING_WAYBILL:
            return {
                ...state,
                outboundBookingWaybill: action.outboundBookingWaybill
            };
        case outboundConstants.OUTBOUND_BOOKING_WAYBILL_TANDEM:
            return {
                ...state,
                outboundBookingTandemWaybill: action.outboundBookingTandemWaybill
            };
        case outboundConstants.BUILD_UP:
            return {
                ...state,
                buildUp: action.buildUp
            }
        case outboundConstants.OUTBOUND_LOADLIST_RELEASE:
            return {
                ...state,
                loadlistRelease: action.loadlistRelease
            };
        case outboundConstants.LOAD_LIST:
            return {
                ...state,
                loadList: action.loadList
            }
        case outboundConstants.TALLY_SHEETS:
            return {
                ...state,
                tallySheets: action.tallySheets
            }
        case outboundConstants.LIST_FOR_CREATE_TALLY_SHEET:
            return {
                ...state,
                listForCreateTallySheet: action.listForCreateTallySheet
            }
        case outboundConstants.TALLY_SHEET:
            return {
                ...state,
                tallySheet: action.tallySheet
            }
        case outboundConstants.STOWAGE:
            return {
                ...state,
                stowage: action.stowage
            }
        case outboundConstants.STOWAGE_FOR_CREATE:
            return {
                ...state,
                stowageForCreate: action.stowageForCreate
            }
        case outboundConstants.STOWAGE_CODE:
            return {
                ...state,
                stowageCode: action.stowageCode
            }
        case outboundConstants.LOADING_CONFIRMATION:
            return {
                ...state,
                loadingConfirmation: action.loadingConfirmation
            }
        case outboundConstants.OUTBOUND_ALL_CTS:
            return {
                ...state,
                outboundAllCts: action.outboundAllCts
            };
        case outboundConstants.VOYAGE_BUILDUP_LIST:
            return {
                ...state,
                voyageBuildUpList: action.voyageBuildUpList
            }
        case outboundConstants.VOYAGE_LOAD_LIST:
            return {
                ...state,
                voyageLoadList: action.voyageLoadList
            }
        case outboundConstants.VOYAGE_TALLYSHEET_LIST:
            return {
                ...state,
                voyageTallySheetList: action.voyageTallySheetList
            }
        case outboundConstants.VOYAGE_STOWAGEPLAN_LIST:
            return {
                ...state,
                voyageStowagePlanList: action.voyageStowagePlanList
            }
        case outboundConstants.VOYAGE_LOADING_CONFIRMATION_LIST:
            return {
                ...state,
                voyageLoadingConfirmationList: action.voyageLoadingConfirmationList
            }
        case outboundConstants.VOYAGE_WAYBILL_LIST:
            return {
                ...state,
                getVoyageWayBillList: action.getVoyageWayBillList
            }
        case outboundConstants.VOYAGE_REGUIDING_LIST:
            return {
                ...state,
                getVoyageReguidingList: action.getVoyageReguidingList
            }
        case outboundConstants.GET_REGUIDE_VOYAGE:
            return {
                ...state,
                getReguideVoyage: action.getReguideVoyage
            }
        case outboundConstants.GET_VOYAGESCHEDULE_FOR_REGUIDE:
            return {
                ...state,
                getVoyageScheduleForReguide: action.getVoyageScheduleForReguide
            }
        case outboundConstants.CLEAR_WAYBILL:
            return {
                outboundBookingWaybill: null,
                outboundWaybill: null
            }
        case outboundConstants.CLEAR_CREATION_TALLYSHEET:
            return {
                listForCreateTallySheet: null,
            }
        case outboundConstants.VOYAGE_CROACCTG_LIST:
            return {
                ...state,
                voyageCROAcctgList: action.voyageCROAcctgList
            }
        case outboundConstants.GET_CROACCTG_BY_VOYAGE:
            return {
                ...state,
                CROAcctgData: action.CROAcctgData
            }
        case outboundConstants.GET_WAYBILL_BY_VOYAGE_CRO_ACCOUNTING:
            return {
                ...state,
                waybillCROACCNT: action.waybillCROACCNT
            }
        case outboundConstants.GET_WAYBILL_DATA_CRO_ACCOUTING:
            return {
                ...state,
                WaybillDataCROAccounting: action.WaybillDataCROAccounting
            }
        case outboundConstants.CLEAR_OUTBOUND:
            return {}
        case outboundConstants.OUTBOUND_BOOKING_LIST:
            return {
                ...state,
                outboundBookingList: action.outboundBookingList
            };
        case outboundConstants.GET_VOYAGE_LOADING_REPORT:
            return {
                ...state,
                LoadingReportData: action.LoadingReportData
            };
        case outboundConstants.GET_VOYAGE_LOADING_REPORT_TALLYSHEET:
            return {
                ...state,
                LoadingReportTallySheetData: action.LoadingReportTallySheetData
            };
        case outboundConstants.GET_PREVIOUS_VOYAGE:
            return {
                ...state,
                PrevVoyage: action.PrevVoyage
            };
        case outboundConstants.GET_DISPATCH_LIST:
            return {
                ...state,
                DispatchList: action.DispatchList
            };
        case outboundConstants.GET_ARCHIVE_DISPATCH_LIST:
            return {
                ...state,
                ArchiveDispatchList: action.ArchiveDispatchList
            };
        case outboundConstants.OUTBOUND_EXEMPTION_CHARGE:
        return {
            ...state,
            ExemptionCharge: action.ExemptionCharge
        };
        case outboundConstants.OUTBOUND_EXEMPTION_CHARGE_TANDEM:
        return {
            ...state,
            ExemptionChargeTandem: action.ExemptionChargeTandem
        };
        case outboundConstants.EXEMPTION_CHARGE_LOADING:
            return {
                ...state,
                exempChrLoading: true
            };
        case outboundConstants.EXEMPTION_CHARGE_LOADED:
            return {
                ...state,
                exempChrLoading: false
            };
        case outboundConstants.SEARCH_SI:
            return {
                ...state,
                SIList: action.SIList
            };
        default:
            return state;
    }
}